{
  "version": 1,
  "asset_id": "1c8e3f8f-8023-411c-8e72-26ef2400db78",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/1c8e3f8f-8023-411c-8e72-26ef2400db78/destination-roofing-blue-metal-roof-lecanto-fl-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/1c8e3f8f-8023-411c-8e72-26ef2400db78/destination-roofing-blue-metal-roof-lecanto-fl-1200w.webp",
  "original_filename": "destination-roofing-blue-metal-roof-lecanto-fl-1200w.webp",
  "size": 111182,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:09Z"
}
